import { createAction, props } from '@ngrx/store';
import { Theme } from '../../admin/models';

export const getTheme = createAction(
  '[Theme] Get Theme',
  props<{
    idTheme: number;
  }>()
);

export const getThemeSuccess = createAction(
  '[Theme] Get Theme success',
  props<{
    theme: Theme;
  }>()
);
export const getThemeFailure = createAction(
  '[Theme] Get Theme failure',
  props<{
    error: string;
  }>()
);

export const clearTheme = createAction('[Theme] Clear Theme');
